import { ReactNode } from 'react';

import { backgroundImage, logoTrz, Divider, Button } from '@treezor/design-system';
import { useTranslation } from 'react-i18next';

import { useAuth2FaContext } from '../context/Auth2FaContext';

import { DefineOwnPassword } from '@/features/dashboard-users/components/changePassword/DefineOwnPassword';
import { BrandingIcon } from '@/ui-kit/BrandingIcon/BrandingIcon';
import { TBrandingIconName } from '@/ui-kit/BrandingIcon/BrandingIcon.types';

import { Auth2FaRegistration } from './Auth2FaRegistration';
import { Auth2FaRegistrationSuccess } from './Auth2FaRegistrationSuccess';
import { Auth2FaRegistrationFail } from './Auth2FaRegistrationFail';
import { Auth2FaAuthentication } from './Auth2FaAuthentication';
import { Auth2FaAuthenticationFail } from './Auth2FaAuthenticationFail';
interface IStep {
  icon?: TBrandingIconName;
  title?: string;
  content: ReactNode;
  shouldHideFooter?: boolean;
}

export function Auth2FaStepper() {
  const { t } = useTranslation();

  const { currentStep, onBack } = useAuth2FaContext();

  const steps: IStep[] = [
    {
      icon: 'verified_v1',
      title: t('pages.auth.2fa.title'),
      content: <Auth2FaRegistration />,
    },
    {
      icon: 'verified_v1',
      title: t('pages.auth.2fa.activated'),
      content: <Auth2FaRegistrationSuccess />,
    },
    {
      icon: 'warning_v1',
      title: t('pages.auth.2fa.activationFail'),
      content: <Auth2FaRegistrationFail />,
    },
    {
      content: <DefineOwnPassword />,
      shouldHideFooter: true,
    },
    {
      icon: 'verified_v1',
      title: t('pages.auth.2fa.authenticating'),
      content: <Auth2FaAuthentication />,
      shouldHideFooter: true,
    },
    {
      icon: 'warning_v1',
      title: t('pages.auth.2fa.fail'),
      content: <Auth2FaAuthenticationFail />,
    },
  ];
  const currentView = steps[currentStep];

  return (
    <div className="w-full h-[100vh] grid grid-cols-2">
      <div
        style={{ backgroundImage: `url(${backgroundImage})` }}
        className="w-full h-full flex flex-col bg-cover gap-11 p-12"
      >
        <img className="block w-[210px]" alt="Treezor Connect" src={logoTrz} />
        <div className="flex flex-col gap-6">
          <h2 className="typo-h2-bold text-onColor">{t('pages.auth.2fa.welcome')}</h2>
          <span className="typo-body-regular-paragraphLarge text-onColor">{t('pages.auth.2fa.welcomeMessage')}</span>
        </div>
      </div>
      <div className="flex flex-col p-8 items-start max-w-[480px] m-auto gap-6">
        {(currentView.icon || currentView.title) && (
          <div className="flex flex-col gap-5">
            <BrandingIcon size="xxl" name={currentView.icon} />
            <h3 className="typo-h3-bold text-secondary">{currentView.title}</h3>
          </div>
        )}
        {currentView.content}
        {!currentView?.shouldHideFooter && (
          <>
            <Divider />
            <div className="w-full flex items-start">
              <Button variant="ghost" icon="arrow_back" onClick={onBack}>
                {t('pages.auth.2fa.backSignIn')}
              </Button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
